module.exports = __webpack_public_path__ + "static/media/50_tn.568724dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/50_tn.jpg
// module id = 686
// module chunks = 0